import { useState, useEffect, useCallback } from "react";
import useFetch from "use-http";

import Indicator from "~/components/shared/Indicator";

type TestEngineConfig = {
  testEngine: {
    testTabUrls?: {
      failureIndicatorUrl: string | null;
    };
  };
};

type Props = {
  translateX?: string;
  translateY?: string;
  build: TestEngineConfig;
  job?: TestEngineConfig;
};

const FailedTestExecutionsContent = ({
  indicatorUrl,
  translateX,
  translateY,
}: {
  indicatorUrl: string;
  translateX: string;
  translateY: string;
}) => {
  const [failures, setFailures] = useState(false);
  const { get, response, error } = useFetch(indicatorUrl);

  const getFailures = useCallback(async () => {
    const data = await get();
    setFailures(response.ok);
  }, [get, response]);

  useEffect(() => {
    getFailures();
  }, [getFailures]);

  if (!failures || error) {
    return null;
  }

  return (
    <span className="absolute right-0 top-0" style={{ translate: `${translateX} ${translateY}` }}>
      <Indicator />
    </span>
  );
};

const FailedTestExecutionsIndicator = ({
  job,
  build,
  translateX = "-6px",
  translateY = "5px",
}: Props) => {
  const tabView = job ? job.testEngine : build.testEngine;
  const indicatorUrl = tabView.testTabUrls?.failureIndicatorUrl;

  if (!indicatorUrl) {
    return null;
  }

  return (
    <FailedTestExecutionsContent
      indicatorUrl={indicatorUrl}
      translateX={translateX}
      translateY={translateY}
    />
  );
};

export default FailedTestExecutionsIndicator;
